import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import ButtomCustom from "../../ButtonRound";
import HttpClient from "../../../helpers/HttpClient";
import { showToast } from "../../../utils/toast";
import OverlayLoader from "../../OverlayLoader";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Question from "./components/Question";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MobileStepper from "../../Steppers/components/MobileStepper";
import AlertModal from "../../Tests/components/AlertModal";
import QuizResults from "./components/Result";

import { getPathCourseResource } from "../../../utils/electronFunctions";

const QuizContainer = ({
  courseCode,
  type,
  data,
  configPercentage,
  onFinalize,
  onContinue,
  readingTimeSeconds = 0
}) => {
  const [openLoader, setOpenOpenLoader] = useState(false);
  const authState = useSelector((state) => state?.auth);
  const userId = authState && authState.user ? authState.user.email : "test";
  const [header, setHeader] = useState(null);
  const [footer, setFooter] = useState(null);
  const [questionsPages, setQuestionsPages] = useState([]);
  const [quizData, setQuizData] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  const [questionAnswer, setQuestionAnswer] = useState([]);
  const [quizResult, setQuizresult] = useState({
    show: false,
    corrects: 0,
    incorrects: 0,
    percentaje: 0,
  });
  const [velocity, setVelocity] = useState(0)

  const imagePaths = async (html, stringImages, path) => {
    const images = stringImages ? stringImages.split(",") : null;
    let content = html;
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let finalPath = "";
        if (images[i].indexOf("commons/") != -1) {
          finalPath = await getPathCourseResource(
            images[i].replace("commons", "commons")
          );
        } else {
          finalPath = await getPathCourseResource(path + "/img/" + images[i]);
        }
        content = content.replace(images[i], finalPath);
      }
    }
    return content;
  };

  const loadData = async () => {
    let url = `/quiz/data/${userId}/${courseCode}/${type}/${
      type == "LESSON" ? data.cod_leccion : data.id
    }/${data.cod_cuestionario}`;

    const quizDataResponse = await HttpClient().get(url);

    if (quizDataResponse.error) {
      setOpenOpenLoader(false);
      showToast("No se pudo cargar información. Intenta nuevamente.", "error");
      return;
    }
    console.log(quizDataResponse.data);
    setQuizData(quizDataResponse.data);
  };

  const setHeaderAndFooter = async () => {
    const path = "cursos/" + courseCode;
    if (quizData?.encabezado && quizData?.encabezado != "") {
      let htmlHeader = quizData.encabezado;
      if (quizData.img_encabezado && quizData.img_encabezado != "") {
        htmlHeader = await imagePaths(
          htmlHeader,
          quizData?.img_encabezado,
          path
        );
      }
      setHeader(htmlHeader);
    } else {
      setHeader(null);
    }

    if (quizData?.pie && quizData?.pie != "") {
      let htmlFooter = quizData?.pie;
      if (quizData?.img_pie && quizData?.img_pie != "") {
        htmlFooter = await imagePaths(htmlFooter, quizData?.img_pie, path);
      }
      setFooter(htmlFooter);
    } else {
      setFooter(null);
    }
  };

  const setQuestionsForPagination = () => {
    quizData.questions.map(function (question, index) {
      question.listOrder = index;
      return question;
    });
    const arPages = [];
    const arPagesAnswers = [];
    if (quizData.preguntas_por_pagina) {
      const numPaginas = Math.ceil(
        quizData.questions.length / Number(quizData.preguntas_por_pagina)
      );

      if (numPaginas > 1) {
        let initCounter = 0;
        const numPerPage = Number(quizData.preguntas_por_pagina);
        for (let i = 0; i < numPaginas; i++) {
          let arForPage = [];
          if (i == numPaginas - 1) {
            arForPage = quizData.questions.slice(initCounter);
          } else {
            arForPage = quizData.questions.slice(
              initCounter,
              initCounter + numPerPage
            );
          }

          if (arForPage.length > 0) {
            arPagesAnswers.push(Array(arForPage.length).fill("0-0-0"));
            arPages.push(arForPage);
            initCounter += numPerPage;
          }
        }
      } else {
        arPagesAnswers.push(Array(quizData.questions.length).fill("0-0-0"));
        arPages.push(quizData.questions);
      }
    } else {
      arPagesAnswers.push(Array(quizData.questions.length).fill("0-0-0"));
      arPages.push(quizData.questions);
    }
    console.log(arPages);
    console.log(arPagesAnswers)

    for(let i = 0; i < arPages.length; i++) {
      const questions = arPages[i];
      for(let j = 0; j < questions.length; j++) {
        if (questions[j].previousAnswer) {
          const newValue = `${questions[j].previousAnswer.value}-${questions[j].options.filter(ele => ele.id == questions[j].previousAnswer.value)[0].respuesta}-${questions[j].id}`
          arPagesAnswers[i][j] = newValue;
        }
      }
    }


    setQuestionsPages(arPages);
    setQuestionAnswer(arPagesAnswers);
  };

  const callbackOptionSelected = (value, indexQuestion) => {
    console.log(value, indexQuestion);
    const arStateAnswers = [...questionAnswer];
    arStateAnswers[currentPageIndex][indexQuestion] = value;
    setQuestionAnswer(arStateAnswers);
  };

  const handlePrevious = () => {
    setCurrentPageIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const validatePageAnswers = () => {
    const arAnswers = questionAnswer[currentPageIndex];
    return arAnswers.filter((ele) => ele == "0-0-0").length == 0;
  };

  const handleNext = () => {
    if (!validatePageAnswers()) {
      showToast("Debes contestar todo");
      return;
    }

    setCurrentPageIndex((prevIndex) =>
      Math.min(prevIndex + 1, questionsPages.length - 1)
    );
  };

  const getPayloadAnwers = () => {
    const answers: any = []
    for (let i = 0; i < questionAnswer.length; i++) {
      const page: any = questionAnswer[i]
      for (let j = 0; j < page.length; j++) {
        const data = page[j].split("-")
        answers.push({
          questionId: data[2],
          answerId: data[0],
          isCorrect: data[1]
        })
      }
    }
    return answers
  } 

  const finalizeExercise = async () => {
    console.log(questionAnswer);
    setOpenOpenLoader(true);
    let corrects = 0;
    for (let i = 0; i < questionAnswer.length; i++) {
      corrects += questionAnswer[i].filter(
        (ele) => ele.split("-")[1] == 1
      ).length;
    }

    const percentage = Math.round((100 * corrects) / quizData.questions.length);

    let requestObject = {
      percentage: percentage,
      answers: getPayloadAnwers()
    }

    if (readingTimeSeconds > 0) {
      requestObject["meta"] = {
        velocity: Math.ceil((Number(data.numero_palabras) * 60) / readingTimeSeconds),
        comprehension: percentage
      }
      setVelocity(requestObject.meta.velocity)
    }

    const request = await HttpClient().post(
      `/quiz/result/${userId}/${courseCode}/${type}/${
        type == "LESSON" ? data.cod_leccion : data.id
      }/${data.cod_cuestionario}`,
      requestObject
    );
    setOpenOpenLoader(false);
    if (request.error) {
      showToast("No se pudo guardar el progreso. Intenta nuevamente.", "error");
      return;
    }
    setIsSaved(true);
    if (percentage >= configPercentage) {
      onFinalize();
    }
    setQuizresult({
      show: true,
      corrects: corrects,
      incorrects: quizData.questions.length - corrects,
      percentaje: percentage 
    })
  };

  useEffect(() => {
    if (quizData) {
      setHeaderAndFooter();
      setQuestionsForPagination();
      setOpenOpenLoader(false);
    }
  }, [quizData]);

  useEffect(() => {
    if (data) {
      setOpenOpenLoader(true);
      loadData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
    }
  }, []);

  return (
    <Grid container columns={{ xs: 4, md: 12 }} spacing={2}>
      <OverlayLoader open={openLoader} />
      <Grid item xs={12}>
        {header ? <div>{parse(header)}</div> : null}
      </Grid>
      <Grid item xs={12}>
        <Card sx={{ marginBottom: 2, width: "100%" }}>
          <CardHeader
            sx={{ display: "" }}
            //avatar={<Avatar>{data.nombre.split("")[0]}</Avatar>}
            action={
              <Stack direction="row" spacing={1}>
                <Chip
                  label={`Página ${currentPageIndex + 1} de ${
                    questionsPages.length
                  }`}
                  component="a"
                  clickable={false}
                />
              </Stack>
            }
            title={data.nombre}
            subheader={`${
              quizData ? quizData?.questions?.length : "0"
            } preguntas`}
          />
        </Card>
        {questionsPages.length && questionsPages.length > 0 ? (
          <>
            {questionsPages[currentPageIndex].map((question, index) => (
              <Question
                key={question.id}
                question={question}
                indexQuestion={index}
                callbackOptionSelected={callbackOptionSelected}
                selectedAnswer={questionAnswer[currentPageIndex][index]}
                pageIndex={currentPageIndex}
                numPerPage={quizData.preguntas_por_pagina}
              />
            ))}
          </>
        ) : null}
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 12 }} style={{ margin: "auto" }}>
        {questionsPages.length > 1 ? (
          <MobileStepper
            steps={questionsPages.length}
            activeStep={currentPageIndex}
            disabledPrevious={false}
            disabledNext={questionsPages.length == currentPageIndex + 1}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            previousText={"Atrás"}
            nextText={"Siguiente"}
            hidePrevious={false}
          />
        ) : null}

        {!isSaved &&
        questionsPages.length == currentPageIndex + 1 &&
        validatePageAnswers() ? (
          <ButtomCustom
            className="lessons-button-container-center"
            variant="outlined"
            sx={{ float: "right" }}
            onClick={finalizeExercise}
            rounded
            startIcon={<CloudUploadIcon />}
          >
            Finalizar
          </ButtomCustom>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        {footer ? <div>{parse(footer)}</div> : null}
      </Grid>

      {isSaved ? (
        <Grid item xs={12} className="lessons-button-container-center">
          <ButtomCustom
            sx={{ marginTop: 1 }}
            onClick={() => {
              onContinue();
            }}
            variant="contained"
            rounded
          >
            Continuar
          </ButtomCustom>
        </Grid>
      ) : null}

      <AlertModal
        open={quizResult.show}
        title={"¡Finalizado!"}
        content={
          <>
            <QuizResults
              percentage={quizResult.percentaje}
              correctAnswers={quizResult.corrects}
              incorrectAnswers={quizResult.incorrects}
              velocity={velocity}
            />
          </>
        }
        buttonText={"Aceptar"}
        onButtonClick={() => {
          setQuizresult({
            ...quizResult,
            show: false,
          })
          onContinue();
        }}
      />
    </Grid>
  );
};

export default QuizContainer;
